export default __webpack_public_path__ + "assets/fi-sr-clock-red.svg";